/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../widgets/livewidget/query/ServiceBase',
	'./api/SmartsServiceAPI',
	'underscore'
], function (APIFactory, ServiceBase, SmartsServiceAPI, _) {
	'use strict';

	class SmartsService extends ServiceBase {

		constructor(options) {
			super();
			this.ajaxSvc = options.features['API'].getGlassCoreSvc('.Ajax');
			this.logger = options.features['API'].getGlassCoreSvc('.Logger');
		}

		getAPI() {
			return APIFactory.createAPI(this, [SmartsServiceAPI]);
		}

		runQuery(options) {
			return this._runQuery(options);
		}

		/**
		 * @public api to excute query against Smart service.
		 *
		 * @param {Object} options.querySpec Mandatory: the query specification to be sent to annotation service
		 * @returns a promise.
		 */
		_runQuery(options) {
			const requestId = this.getRequestId(options.sender);

			return new Promise((resolve, reject) => {
				this.ajaxSvc.ajax({
					type: 'post',
					url: options.url,
					contentType: 'application/json',
					data: JSON.stringify(options.querySpec)
				}).then((data) => {
					if (this.isActiveRequest(requestId, options.sender)) {
						resolve(data);
					} else {
						reject(_.extend(new Error(), {
							reason: 'staleRequest'
						}));
					}
				}, (err) => {
					reject(err);
				});
			});
		}
	}

	return SmartsService;
});
